{
  "list": {
    "searchPlaceholder": "Find a lesson, symptom, or incident",
    "searchLabel": "Search proposals",
    "waited": "Waiting {{age}}",
    "proposedLesson": "Proposed lesson",
    "emptyTitle": "No proposals awaiting action",
    "emptyMessage": "New lessons and held proposals will appear here when they need a decision.",
    "emptyFilteredMessage": "No proposal matches these filters.",
    "errorTitle": "Proposals unavailable",
    "fetchFailed": "Could not fetch the review queue."
  },
  "table": {
    "proposal": "Proposal",
    "status": "Status",
    "scope": "Scope",
    "sources": "Sources",
    "waiting": "Waiting"
  },
  "detail": {
    "notFoundTitle": "Proposal not found",
    "notFoundMessage": "It may have been decided or withdrawn since the queue loaded.",
    "fetchFailed": "Could not load the proposal.",
    "showFull": "Show full statement",
    "showLess": "Show less",
    "proposedBy": "Proposed by {{who}}",
    "proposedByUnknown": "Proposed by an unrecorded author",
    "origins": "{{count}} independent source",
    "origins_plural": "{{count}} independent sources",
    "published": "Published for reuse",
    "publishedMessage": "This decision is recorded. Published memories can appear in future authorized snapshots.",
    "stale": "Review the updated proposal",
    "staleMessage": "The proposal or evidence changed while you were reviewing. The latest details are loaded. Review them before submitting a new decision.",
    "decisionRecorded": "Decision recorded. Status: {{status}}.",
    "versionsMissing": "Current proposal and evidence versions are missing. Refresh this proposal before reviewing.",
    "decideFailed": "Could not record the decision.",
    "decideSuccess": "Your decision has been recorded.",
    "proposalId": "Proposal ID",
    "version": "Version",
    "evidenceSetHash": "Evidence set"
  },
  "formation": {
    "summary": "How this proposal formed",
    "sources": "{{count}} source",
    "sources_plural": "{{count}} sources",
    "collectedEvidence": "Collected evidence",
    "excerpts": "{{count}} excerpt",
    "excerpts_plural": "{{count}} excerpts",
    "collected": "Collected from sources",
    "notReadable": "Not readable with your access",
    "investigation": "Investigation",
    "notLinked": "Not linked",
    "humanReview": "Human review",
    "approved": "Approved",
    "byReviewer": "By a reviewer",
    "rejected": "Rejected",
    "notPublished": "Not published",
    "lesson": "Lesson",
    "publishedNote": "Published",
    "notYet": "Not published yet"
  },
  "admission": {
    "title": "Admission checks",
    "evidence_support": "Evidence supports the statement",
    "scope_fit": "Fits the requested scope",
    "instruction_injection": "No instructions hidden in sources",
    "equivalence": "Not a duplicate of an existing lesson",
    "counterevidence_material": "No material counterevidence",
    "flagged": "Flagged",
    "lowRisk": "Low risk",
    "judgeFailed": "The judge did not finish",
    "judgeFailedMessage": "{{status}}. Decide from the evidence below.",
    "fixtureNote": "Fixture judge: these values are canned test outputs and did not assess this evidence. Read the evidence and the investigation yourself.",
    "liveCall": "Live model call",
    "fixtureCall": "Fixture judge, not a live model",
    "latestOf": "latest of {{count}} assessments",
    "advises": "The judge advises; only a reviewer publishes.",
    "raw": "Raw assessment"
  },
  "investigation": {
    "title": "What the investigation recorded",
    "compare": "Compare this lesson with its investigation",
    "conflictFailed": "The investigation recorded a failed attempt: “{{text}}”.",
    "conflictRejected": "The investigation recorded a rejected hypothesis: “{{text}}”.",
    "repeats": "The statement repeats it without saying it failed.",
    "outcome": "Outcome",
    "symptom": "Symptom",
    "failedAttempts": "Failed attempts",
    "rejectedHypotheses": "Rejected hypotheses",
    "recovery": "Recovery verification",
    "window": "window {{window}}",
    "from": "From {{id}} v{{version}}."
  },
  "sections": {
    "whyDecision": "Why a decision is needed",
    "requestedEvidence": "Requested evidence",
    "useWhen": "Use this when",
    "noConditions": "No conditions supplied. Check whether this lesson generalizes within the requested scope.",
    "dontRelyWhen": "Don't rely on it when",
    "noLimitations": "No limitations supplied.",
    "evidence": "Supporting evidence",
    "noEvidenceTitle": "No readable evidence attached",
    "noEvidenceMessage": "This proposal does not include evidence you can read in your current scope. It may need additional evidence before publication.",
    "scope": "Requested scope",
    "claimType": "Claim type",
    "originatingInvestigation": "Originating investigation",
    "reviews": "Reviews so far",
    "noReviews": "No decision recorded yet.",
    "details": "Details"
  },
  "evidence": {
    "supports": "Supports",
    "counterevidence": "Counterevidence",
    "truncated": "Excerpt truncated",
    "notAvailable": "Excerpt not available.",
    "revision": "Revision {{revision}}"
  },
  "decision": {
    "title": "Your decision",
    "help": "Agents can’t publish. Approval publishes to {{scope}} only.",
    "observer": "Your session can observe this proposal. A reviewer must make the decision.",
    "unavailable": "No review action is available for this proposal’s current state.",
    "approve": "Approve",
    "request_evidence": "Request evidence",
    "reject": "Reject",
    "rationale": "Reason for your decision",
    "rationalePlaceholder": "Explain how the evidence supports your decision.",
    "rationaleRequired": "Explain the reason for your decision.",
    "requiredEvidence": "Evidence needed · one request per line",
    "requiredEvidencePlaceholder": "Verify recovery in a production metric window.",
    "requiredEvidenceRequired": "Name at least one concrete evidence request.",
    "confirmation": "I reviewed the supporting evidence and the requested scope of this lesson.",
    "confirmationRequired": "Confirm that you reviewed the evidence and scope.",
    "submit": "Record decision",
    "submitting": "Recording decision…",
    "approveStatus": "Approval recorded",
    "rejectStatus": "Rejection recorded",
    "request_evidenceStatus": "Evidence request recorded"
  },
  "reviewDecision": {
    "approve": "Approved",
    "reject": "Rejected",
    "request_evidence": "Evidence requested",
    "defer": "Deferred"
  }
}
